/* NEWLUNA — core interactions: header, menu, motion, launch countdown, cart. */
(function () {
  'use strict';
  var N = window.Newluna = window.Newluna || {};
  var root = document.documentElement;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = root.classList.contains('reduce-motion');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  N.$ = $; N.$$ = $$; N.reduceMotion = reduce;

  /* ---------- Money: mirrors the shop's own format via a formatted sample ---------- */
  N.formatMoney = (function () {
    var tpl = String(N.moneyTemplate || '€1,234,567.89');
    var first = tpl.search(/\d/), last = tpl.length - 1 - tpl.split('').reverse().join('').search(/\d/);
    var prefix = tpl.slice(0, first), suffix = tpl.slice(last + 1), body = tpl.slice(first, last + 1);
    var m = body.match(/^(\d{1,3}(?:(\D)\d{3})*)(?:(\D)(\d{2}))?$/);
    var thou = (m && m[2]) || ',', dec = (m && m[3]) || '', decimals = m && m[4] ? 2 : 0;
    return function (cents) {
      var n = Math.round(Number(cents) || 0), neg = n < 0;
      n = Math.abs(n);
      var whole = decimals ? Math.floor(n / 100) : Math.round(n / 100);
      var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      if (decimals) s += dec + String(n % 100).padStart(2, '0');
      return (neg ? '-' : '') + prefix + s + suffix;
    };
  })();

  /* Plug standard for the visitor's country (LED mask plug options: US, EU, UK, AU) */
  N.preferredPlug = function () {
    var c = String(N.country || '').toUpperCase();
    if (['US', 'CA', 'MX', 'JP', 'PR', 'TW', 'PH', 'TH', 'CO', 'VE', 'EC', 'PE'].indexOf(c) > -1) return 'US';
    if (['GB', 'IE', 'MT', 'CY', 'HK', 'SG', 'MY', 'AE', 'QA', 'SA', 'KW', 'BH'].indexOf(c) > -1) return 'UK';
    if (['AU', 'NZ', 'FJ', 'PG', 'AR', 'CN'].indexOf(c) > -1) return 'AU';
    return 'EU';
  };

  N.announce = function (msg) {
    var el = $('[data-announcer]');
    if (!el) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 60);
  };

  /* ---------- Scroll lock + focus trap helpers ---------- */
  var lockCount = 0;
  function lockScroll(on) {
    lockCount = Math.max(0, lockCount + (on ? 1 : -1));
    var sw = window.innerWidth - root.clientWidth;
    if (lockCount > 0) { root.style.overflow = 'hidden'; document.body.style.paddingRight = sw > 0 ? sw + 'px' : ''; }
    else { root.style.overflow = ''; document.body.style.paddingRight = ''; }
  }
  function trapFocus(container, e) {
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  N.lockScroll = lockScroll;
  N.trapFocus = trapFocus;

  /* ---------- Header ---------- */
  function initHeader() {
    var wrap = $('[data-header-wrap]');
    var header = $('[data-header]');
    if (!wrap || !header) return;
    var hero = $('[data-hero]');
    var overlay = header.hasAttribute('data-overlay') && hero;
    if (overlay) header.classList.add('is-overlay');
    else header.classList.add('is-solid');
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY;
      wrap.classList.toggle('is-scrolled', y > 24);
      if (overlay) {
        var limit = hero.offsetHeight - header.offsetHeight - 10;
        header.classList.toggle('is-solid', y > limit);
      }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var menu = $('[data-mnav]');
    if (!menu) return;
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      $$('[data-mnav-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      lockScroll(true);
      setTimeout(function () { var c = $('[data-mnav-close]', menu); if (c) c.focus(); }, 50);
    }
    function close() {
      if (!menu.classList.contains('is-open')) return;
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      $$('[data-mnav-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      lockScroll(false);
      if (lastFocus) lastFocus.focus();
    }
    $$('[data-mnav-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-mnav-close]', menu).forEach(function (b) { b.addEventListener('click', close); });
    menu.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); trapFocus(menu, e); });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', close); });
  }

  /* ---------- Small enhancements ---------- */
  function initAutosubmit() {
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (el.matches && el.matches('[data-autosubmit]')) el.form.submit();
    });
  }

  function initReveal() {
    var els = $$('[data-reveal], [data-reveal-img]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-revealed'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-revealed'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -12% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initMagnetic() {
    if (reduce || !finePointer) return;
    $$('[data-magnetic]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2;
        el.style.transform = 'translate(' + (x * 0.22).toFixed(1) + 'px,' + (y * 0.32).toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  function initAccordions() {
    if (reduce || !Element.prototype.animate) return;
    document.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('details.acc > summary');
      if (!s) return;
      var d = s.parentElement, body = $('.acc__body', d);
      if (!body || d.dataset.animating) return;
      e.preventDefault();
      d.dataset.animating = '1';
      body.style.overflow = 'hidden';
      var done = function () { delete d.dataset.animating; body.style.overflow = ''; };
      if (d.open) {
        var h = body.offsetHeight;
        body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.65,0,.35,1)' })
          .onfinish = function () { d.open = false; done(); };
      } else {
        d.open = true;
        var h2 = body.offsetHeight;
        body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 460, easing: 'cubic-bezier(.16,1,.3,1)' })
          .onfinish = done;
      }
    });
  }

  function initTabs() {
    $$('[data-filter-tabs]').forEach(function (tabs) {
      var grid = document.getElementById(tabs.getAttribute('data-filter-tabs'));
      if (!grid) return;
      tabs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-filter]');
        if (!b) return;
        var f = b.getAttribute('data-filter');
        $$('[data-filter]', tabs).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('[data-product-card]', grid).forEach(function (card) {
          var cats = (card.getAttribute('data-category') || '').split(' ');
          card.classList.toggle('is-filtered-out', f !== 'all' && cats.indexOf(f) === -1);
        });
      });
    });
  }

  /* ---------- Hero: intro, scroll progress, card parallax ---------- */
  function initHero() {
    var hero = $('[data-hero]');
    if (!hero) return;
    requestAnimationFrame(function () { setTimeout(function () { hero.classList.add('is-in'); }, 60); });
    if (reduce) return;
    var ticking = false;
    function onScroll() {
      ticking = false;
      var h = hero.offsetHeight || 1;
      var p = Math.min(1, Math.max(0, window.scrollY / h));
      hero.style.setProperty('--p', p.toFixed(4));
      N.heroProgress = p;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
    if (!finePointer) return;
    var cards = $$('.hero-card[data-depth]', hero);
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      var nx = (e.clientX - r.left) / r.width - 0.5, ny = (e.clientY - r.top) / r.height - 0.5;
      N.heroPointer = { x: nx * 2, y: -ny * 2 };
      cards.forEach(function (c) {
        var d = parseFloat(c.getAttribute('data-depth')) || 1;
        c.style.setProperty('--tx', (-nx * 26 * d).toFixed(1) + 'px');
        c.style.setProperty('--ty', (-ny * 20 * d).toFixed(1) + 'px');
      });
    });
    hero.addEventListener('pointerleave', function () {
      N.heroPointer = null;
      cards.forEach(function (c) { c.style.setProperty('--tx', '0px'); c.style.setProperty('--ty', '0px'); });
    });
  }

  /* ---------- Showcase: scroll-driven product stage ---------- */
  function initShowcase() {
    $$('[data-showcase]').forEach(function (sc) {
      var chapters = $$('[data-chapter]', sc), imgs = $$('.stage__img', sc), counter = $('[data-stage-counter]', sc);
      var plate = $('[data-stage-plate]', sc);
      function activate(i) {
        chapters.forEach(function (c, j) { c.classList.toggle('is-active', i === j); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', i === j); });
        if (counter) counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(chapters.length).padStart(2, '0');
      }
      activate(0);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) activate(chapters.indexOf(en.target)); });
        }, { rootMargin: '-45% 0px -45% 0px' });
        chapters.forEach(function (c) { io.observe(c); });
      }
      if (plate && finePointer && !reduce) {
        var stage = plate.parentElement;
        stage.addEventListener('pointermove', function (e) {
          var r = stage.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          plate.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg');
          plate.style.setProperty('--rx', (-y * 14).toFixed(2) + 'deg');
        });
        stage.addEventListener('pointerleave', function () { plate.style.setProperty('--rx', '0deg'); plate.style.setProperty('--ry', '0deg'); });
      }
    });
  }

  /* ---------- Before / after ---------- */
  function initCompare() {
    $$('[data-compare]').forEach(function (frame) {
      var range = $('input[type="range"]', frame);
      if (!range) return;
      var set = function () { frame.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Launch countdown ---------- */
  function pad(n) { return String(n).padStart(2, '0'); }
  function setDigits(el, value) {
    var str = pad(value);
    var digits = $$('.cd-digit', el);
    if (digits.length !== str.length) {
      el.innerHTML = str.split('').map(function (d) { return '<span class="cd-digit">' + d + '</span>'; }).join('');
      return;
    }
    digits.forEach(function (span, i) {
      if (span.textContent !== str[i]) {
        span.textContent = str[i];
        if (!reduce) { span.classList.remove('is-tick'); void span.offsetWidth; span.classList.add('is-tick'); }
      }
    });
  }
  function endLaunch() {
    N.launch.live = false;
    root.classList.remove('launch-live');
    document.dispatchEvent(new CustomEvent('newluna:launch-change', { detail: { live: false } }));
  }
  function initLaunch() {
    var L = N.launch || {};
    var start = Date.parse(L.start || ''), end = Date.parse(L.end || '');
    if (!L.enabled || isNaN(end)) return;
    if (!L.live && !isNaN(start) && Date.now() < start && start - Date.now() < 864e5) {
      setTimeout(function () { L.live = true; root.classList.add('launch-live'); document.dispatchEvent(new CustomEvent('newluna:launch-change', { detail: { live: true } })); initLaunch(); }, start - Date.now() + 50);
      return;
    }
    if (!L.live) return;
    var fmt;
    try {
      fmt = new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }).format(new Date(end));
    } catch (e) { fmt = new Date(end).toLocaleString(); }
    $$('[data-cd-end]').forEach(function (el) { el.textContent = fmt; el.setAttribute('datetime', new Date(end).toISOString()); });
    var boxes = $$('[data-countdown]'), bars = $$('[data-launch-time]');
    (function tick() {
      var ms = end - Date.now();
      if (ms <= 0) { endLaunch(); return; }
      var s = Math.floor(ms / 1000);
      var v = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
      boxes.forEach(function (box) { ['d', 'h', 'm', 's'].forEach(function (k) { var el = $('[data-cd="' + k + '"]', box); if (el) setDigits(el, v[k]); }); });
      bars.forEach(function (el) { el.textContent = v.d > 0 ? v.d + 'd ' + pad(v.h) + 'h ' + pad(v.m) + 'm' : pad(v.h) + ':' + pad(v.m) + ':' + pad(v.s); });
      setTimeout(tick, 1000 - (Date.now() % 1000) + 5);
    })();
  }

  /* ---------- Cart ---------- */
  var Cart = N.cart = {
    drawer: null,
    lastFocus: null,
    sectionIds: function () {
      var ids = ['cart-drawer'];
      $$('[data-cart-section]').forEach(function (el) { ids.push(el.getAttribute('data-cart-section')); });
      return ids;
    },
    request: function (url, body) {
      body = body || {};
      body.sections = Cart.sectionIds().join(',');
      body.sections_url = window.location.pathname;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
          return data;
        });
      });
    },
    render: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (id === 'cart-drawer') {
          var fresh = $('[data-drawer-content]', doc), cur = $('[data-drawer-content]');
          if (fresh && cur) cur.replaceWith(fresh);
          var count = fresh ? fresh.getAttribute('data-item-count') : null;
          if (count !== null) Cart.setCount(parseInt(count, 10));
        } else {
          var target = document.getElementById('shopify-section-' + id);
          var src = doc.getElementById('shopify-section-' + id);
          if (target && src) target.innerHTML = src.innerHTML;
        }
      });
      document.dispatchEvent(new CustomEvent('newluna:cart-rendered'));
    },
    setCount: function (n) {
      $$('[data-cart-count]').forEach(function (el) {
        var changed = el.getAttribute('data-count') !== String(n);
        el.setAttribute('data-count', n);
        el.textContent = n > 0 ? n : '';
        if (changed && n > 0 && !reduce) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
      });
    },
    add: function (items, opts) {
      opts = opts || {};
      return Cart.request(N.routes.cartAdd + '.js', { items: items }).then(function (data) {
        if (opts.source) Cart.fly(opts.source);
        Cart.render(data.sections);
        N.announce((items.length > 1 ? items.length + ' items' : 'Item') + ' added to your bag');
        if (N.cartDrawer !== false && !opts.stay) setTimeout(Cart.open, opts.source && !reduce ? 420 : 0);
        return data;
      });
    },
    change: function (key, qty) {
      var d = $('[data-drawer]');
      if (d) d.classList.add('is-busy');
      return Cart.request(N.routes.cartChange + '.js', { id: key, quantity: qty }).then(function (data) {
        Cart.render(data.sections);
        Cart.setCount(data.item_count);
        N.announce('Your bag was updated');
      }).catch(function (err) { alert(err.message); }).then(function () { if (d) d.classList.remove('is-busy'); });
    },
    open: function () {
      var d = $('[data-drawer]');
      if (!d || d.classList.contains('is-open')) return;
      Cart.lastFocus = document.activeElement;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      setTimeout(function () { var p = $('.drawer__panel', d); if (p) p.focus({ preventScroll: true }); }, 80);
    },
    close: function () {
      var d = $('[data-drawer]');
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (Cart.lastFocus && Cart.lastFocus.focus) Cart.lastFocus.focus({ preventScroll: true });
    },
    fly: function (img) {
      if (reduce || !img || !img.getBoundingClientRect || !Element.prototype.animate) return;
      var target = $$('[data-cart-icon]').filter(function (el) { return el.offsetParent !== null; })[0];
      if (!target) return;
      var a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
      if (!a.width) return;
      var size = Math.min(a.width, a.height, 160);
      var el = document.createElement('div');
      el.className = 'fly';
      el.style.cssText = 'left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (a.top + a.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px';
      el.innerHTML = '<img alt="" src="' + (img.currentSrc || img.src) + '">';
      document.body.appendChild(el);
      var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
      el.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.55 - 80) + 'px) scale(.55)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: 0.2 }
      ], { duration: 820, easing: 'cubic-bezier(.5,0,.2,1)' }).onfinish = function () { el.remove(); };
    }
  };

  function initCart() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      var openBtn = t.closest('[data-cart-open]');
      if (openBtn && $('[data-drawer]') && N.cartDrawer !== false) { e.preventDefault(); Cart.open(); return; }
      if (t.closest('[data-drawer-close]')) { e.preventDefault(); Cart.close(); return; }
      var qa = t.closest('[data-quick-add]');
      if (qa) {
        e.preventDefault();
        var card = qa.closest('[data-product-card], .mini, .chapter, .hero-card');
        var img = card ? $('img', card) : null;
        qa.disabled = true;
        Cart.add([{ id: Number(qa.getAttribute('data-quick-add')), quantity: 1 }], { source: img })
          .then(function () { qa.classList.add('is-added'); setTimeout(function () { qa.classList.remove('is-added'); }, 1600); })
          .catch(function (err) { alert(err.message); })
          .then(function () { qa.disabled = false; });
        return;
      }
      var step = t.closest('[data-qty-step]');
      if (step) {
        e.preventDefault();
        var key = step.getAttribute('data-key'), q = parseInt(step.getAttribute('data-qty-step'), 10);
        Cart.change(key, Math.max(0, q));
      }
    });
    document.addEventListener('change', function (e) {
      var inp = e.target.closest && e.target.closest('[data-qty-input]');
      if (inp) Cart.change(inp.getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) || 0));
    });
    document.addEventListener('keydown', function (e) {
      var d = $('[data-drawer].is-open');
      if (!d) return;
      if (e.key === 'Escape') Cart.close();
      trapFocus($('.drawer__panel', d), e);
    });
    // AJAX product forms
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('form[data-product-form]');
      if (!form) return;
      e.preventDefault();
      var btn = $('[type="submit"]', form), err = $('[data-form-error]', form.closest('[data-product-root]') || form);
      var fd = new FormData(form);
      var item = { id: Number(fd.get('id')), quantity: Math.max(1, parseInt(fd.get('quantity') || '1', 10)) };
      var props = {};
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
      if (Object.keys(props).length) item.properties = props;
      if (err) err.hidden = true;
      if (btn) btn.classList.add('is-loading');
      var root = form.closest('[data-product-root]');
      var img = root ? $('.gallery__slide.is-current img, .gallery__slide img', root) : null;
      Cart.add([item], { source: img }).then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); }
      }).catch(function (ex) {
        if (btn) btn.classList.remove('is-loading');
        if (err) { err.textContent = ex.message; err.hidden = false; } else alert(ex.message);
      });
    });
  }

  function init() {
    initHeader();
    initMenu();
    initAutosubmit();
    initReveal();
    initMagnetic();
    initAccordions();
    initTabs();
    initHero();
    initShowcase();
    initCompare();
    initLaunch();
    initCart();
    document.dispatchEvent(new CustomEvent('newluna:ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();